module.exports = __webpack_public_path__ + "static/work25-1737a9edbb283c3e33be5377c239c5c7.jpg";